import { createReducer } from '../utils';

const SHOW_SIGN_IN = 'bamboo-developments/modals/SHOW_SIGN_IN';
const HIDE_SIGN_IN = 'bamboo-developments/modals/HIDE_SIGN_IN';
const SHOW_REGISTER = 'bamboo-developments/modals/SHOW_REGISTER';
const HIDE_REGISTER = 'bamboo-developments/modals/HIDE_REGISTER';
const SHOW_FORGOTTEN = 'bamboo-developments/modals/SHOW_FORGOTTEN';
const HIDE_FORGOTTEN = 'bamboo-developments/modals/HIDE_FORGOTTEN';

const initialState = {
  showSignIn: false,
  showRegister: false,
  showForgotten: false,
  isError: false,
};

export function showSignIn() {
  return { type: SHOW_SIGN_IN };
}

export function hideSignIn() {
  return { type: HIDE_SIGN_IN };
}

export function showRegister() {
  return { type: SHOW_REGISTER };
}

export function hideRegister() {
  return { type: HIDE_REGISTER };
}

export function showForgotten() {
  return { type: SHOW_FORGOTTEN };
}

export function hideForgotten() {
  return { type: HIDE_FORGOTTEN };
}

export function hideAuthDialogs() {
  return (dispatch) => {
    dispatch(hideSignIn());
    dispatch(hideRegister());
  }
}

export default createReducer(initialState, {
  [SHOW_SIGN_IN]: state => ({
    ...state,
    showSignIn: true,
    showRegister: false,
    showForgotten: false,
  }),
  [HIDE_SIGN_IN]: state => ({
    ...state,
    showSignIn: false,
  }),
  [SHOW_REGISTER]: state => ({
    ...state,
    showRegister: true,
    showSignIn: false,
    showForgotten: false,
  }),
  [HIDE_REGISTER]: state => ({
    ...state,
    showRegister: false,
  }),
  [SHOW_FORGOTTEN]: state => ({
    ...state,
    showForgotten: true,
    showRegister: false,
    showSignIn: false,
  }),
  [HIDE_FORGOTTEN]: state => ({
    ...state,
    showForgotten: false,
  }),
});



// WEBPACK FOOTER //
// ./src/redux/modals.js